<template>
  <div class="contact">
    <div class="container">
      <h1 class="contact__title">联系我们</h1>

      <div class="contact__content">
        <!-- 联系方式展示模块 -->
        <div class="contact__info">
          <h2 class="contact__info-title">联系方式</h2>
          <div class="contact__info-list">
            <div class="contact__info-item">
              <div class="contact__info-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 2C8.13 2 5 5.13 5 9C5 14.25 12 22 12 22C12 22 19 14.25 19 9C19 5.13 15.87 2 12 2ZM12 11.5C10.34 11.5 9 10.16 9 8.5C9 6.84 10.34 5.5 12 5.5C13.66 5.5 15 6.84 15 8.5C15 10.16 13.66 11.5 12 11.5Z" fill="currentColor"/>
                </svg>
              </div>
              <div class="contact__info-text">
                <h3>公司地址</h3>
                <p>{{ contactInfo.address }}</p>
              </div>
            </div>

            <div class="contact__info-item">
              <div class="contact__info-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M20 15.5C18.8 15.5 17.5 15.3 16.4 14.9C16.3 14.9 16.2 14.9 16.1 14.9C15.8 14.9 15.6 15 15.4 15.2L13.2 17.4C10.4 15.9 8.2 13.6 7 11L9.2 8.8C9.4 8.6 9.5 8.4 9.5 8.1C9.5 8 9.5 7.9 9.4 7.8C9 6.7 8.8 5.4 8.8 4.2C8.8 3.5 8.2 3 7.5 3H4.5C3.8 3 3.2 3.5 3.2 4.2C3.2 13.1 9.9 20.8 18.8 20.8C19.5 20.8 20 20.2 20 19.5V16.5C20 15.8 19.5 15.5 18.8 15.5H20Z" fill="currentColor"/>
                </svg>
              </div>
              <div class="contact__info-text">
                <h3>联系电话</h3>
                <p>{{ contactInfo.phone }}</p>
              </div>
            </div>

            <div class="contact__info-item">
              <div class="contact__info-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M4 4H20C21.1 4 22 4.9 22 6V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18V6C2 4.9 2.9 4 4 4ZM20 8L12 13L4 8V6L12 11L20 6V8Z" fill="currentColor"/>
                </svg>
              </div>
              <div class="contact__info-text">
                <h3>电子邮箱</h3>
                <p>{{ contactInfo.email }}</p>
              </div>
            </div>

            <div class="contact__info-item">
              <div class="contact__info-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM12 6C10.9 6 10 6.9 10 8C10 9.1 10.9 10 12 10C13.1 10 14 9.1 14 8C14 6.9 13.1 6 12 6ZM12 18C10.34 18 9 16.66 9 15C9 13.34 10.34 12 12 12C13.66 12 15 13.34 15 15C15 16.66 13.66 18 12 18Z" fill="currentColor"/>
                </svg>
              </div>
              <div class="contact__info-text">
                <h3>工作时间</h3>
                <p>{{ contactInfo.workingHours }}</p>
              </div>
            </div>
          </div>
        </div>

        <!-- 咨询与报告服务模块 -->
        <div class="consult-panel">
          <div class="consult-tabs">
            <button
              type="button"
              class="consult-tab"
              :class="{ active: consultTab === 'submit' }"
              @click="switchTab('submit')"
            >提交咨询</button>
            <button
              type="button"
              class="consult-tab"
              :class="{ active: consultTab === 'track' }"
              @click="switchTab('track')"
            >我的咨询</button>
            <button
              type="button"
              class="consult-tab"
              :class="{ active: consultTab === 'query' }"
              @click="switchTab('query')"
            >报告查询</button>
            <button
              type="button"
              class="consult-tab"
              :class="{ active: consultTab === 'mine' }"
              @click="switchTab('mine')"
            >我的报告</button>
          </div>

          <!-- 提交咨询表单 -->
          <div v-if="consultTab === 'submit'" class="consult-form">
            <div class="form-group">
              <label class="form-label">咨询类型<span class="required">*</span></label>
              <select v-model="form.consultTypeId" class="form-control">
                <option :value="null" disabled>请选择咨询类型</option>
                <option v-for="item in consultTypes" :key="item.id" :value="item.id">
                  {{ item.name }}
                </option>
              </select>
            </div>

            <div class="form-group">
              <label class="form-label">咨询标题<span class="required">*</span></label>
              <input v-model.trim="form.title" class="form-control" placeholder="请输入咨询标题" maxlength="50" />
            </div>

            <div class="form-group">
              <label class="form-label">咨询内容<span class="required">*</span></label>
              <textarea v-model.trim="form.content" class="form-textarea" placeholder="请详细描述您的问题" rows="5" maxlength="600"></textarea>
            </div>

            <div class="form-group">
              <label class="form-label">联系人<span class="required">*</span></label>
              <input v-model.trim="form.contactName" class="form-control" placeholder="请输入您的姓名" maxlength="20" />
            </div>

            <div class="form-group">
              <label class="form-label">联系电话<span class="required">*</span></label>
              <input v-model.trim="form.contactPhone" class="form-control" placeholder="请输入您的手机号" maxlength="11" inputmode="tel" />
            </div>

            <button type="button" class="form-submit" :disabled="submitting" @click="submitConsult">
              {{ submitting ? '提交中...' : '提交咨询' }}
            </button>

            <div v-if="selectedTypeContact" class="type-contact-tip">
              如有疑问可联系：{{ selectedTypeContact }}
            </div>
          </div>

          <!-- 我的咨询跟踪 -->
          <div v-if="consultTab === 'track'" class="consult-track">
            <div class="track-search">
              <input v-model.trim="trackPhone" class="form-control" placeholder="请输入提交咨询时填写的手机号" maxlength="11" inputmode="tel" @keyup.enter="searchTrack" />
              <button type="button" class="track-search-btn" :disabled="trackLoading" @click="searchTrack">查询</button>
            </div>

            <div class="track-status-bar" v-if="trackSearched">
              <button
                v-for="item in statusFilters"
                :key="item.value"
                type="button"
                class="status-chip"
                :class="{ active: trackStatus === item.value }"
                @click="changeStatus(item.value)"
              >{{ item.label }}</button>
            </div>

            <div v-if="trackLoading" class="track-state">加载中...</div>
            <div v-else-if="trackSearched && !trackList.length" class="track-state">暂无咨询记录</div>

            <div class="track-list">
              <div
                v-for="item in trackList"
                :key="item.id"
                class="track-card"
                @click="openDetail(item.id)"
              >
                <div class="track-card-head">
                  <span class="track-title">{{ item.title }}</span>
                  <span class="track-status" :class="item.status">{{ statusText(item.status) }}</span>
                </div>
                <div class="track-meta">
                  <span>{{ item.consultTypeName || '未分类' }}</span>
                  <span>{{ formatTime(item.crTime) }}</span>
                </div>
                <div class="track-content">{{ item.content }}</div>
              </div>
            </div>

            <button
              v-if="trackList.length && trackHasMore"
              type="button"
              class="track-more"
              :disabled="trackLoading"
              @click="loadMore"
            >{{ trackLoading ? '加载中...' : '加载更多' }}</button>
          </div>

          <!-- 报告查询 -->
          <div v-if="consultTab === 'query'" class="report-query">
            <div class="form-group">
              <label class="form-label">检品编号<span class="required">*</span></label>
              <input v-model.trim="reportForm.jybh" class="form-control" placeholder="请输入检品编号" maxlength="50" />
            </div>

            <div class="form-group">
              <label class="form-label">委托单位<span class="required">*</span></label>
              <input v-model.trim="reportForm.wtdw" class="form-control" placeholder="请输入委托单位名称" maxlength="100" />
            </div>

            <div class="form-group">
              <label class="form-label">联系电话<span class="required">*</span></label>
              <input v-model.trim="reportForm.lxdh" class="form-control" placeholder="请输入送检时预留的联系电话" maxlength="20" inputmode="tel" />
            </div>

            <div class="report-security-tip">检品编号、委托单位、联系电话三项信息需与送检记录完全一致方可查询，查询前需完成行为验证码校验。</div>

            <button
              type="button"
              class="form-submit"
              :disabled="reportQuerying || reportCaptchaLoading"
              @click="queryReport"
            >{{ reportQueryText }}</button>

            <div v-if="reportResult" class="report-result">
              <div class="report-result-head">
                <span class="report-result-title">查询成功</span>
                <span class="track-status replied">已出报告</span>
              </div>
              <div class="report-result-meta">
                <span>检品编号：{{ reportForm.jybh }}</span>
                <span>委托单位：{{ reportForm.wtdw }}</span>
                <span>报告编号：{{ reportResult }}</span>
              </div>
              <div class="report-result-actions">
                <button type="button" class="report-action-btn preview" @click="previewReport(reportResult)">在线预览</button>
                <button type="button" class="report-action-btn download" @click="downloadReport(reportResult)">下载报告</button>
                <button type="button" class="track-more" @click="goMyReports">查看我的报告</button>
              </div>
            </div>
          </div>

          <!-- 我的报告（本机缓存的查询记录） -->
          <div v-if="consultTab === 'mine'" class="report-mine">
            <div class="report-mine-tip">以下为当前浏览器缓存的报告查询记录，更换设备或清理浏览器数据后将无法查看。</div>

            <div v-if="!reportRecords.length" class="track-state">暂无报告记录，请先在"报告查询"中查询</div>

            <div class="track-list">
              <div v-for="item in reportRecords" :key="item.reportId" class="track-card report-card">
                <div class="track-card-head">
                  <span class="track-title">{{ item.jybh }}</span>
                  <div class="report-card-actions">
                    <button type="button" class="report-card-link" @click="previewReport(item.reportId)">预览</button>
                    <button type="button" class="report-card-link" @click="downloadReport(item.reportId)">下载</button>
                  </div>
                </div>
                <div class="track-meta">
                  <span>委托单位：{{ item.wtdw }}</span>
                  <span>{{ formatTime(item.crTime) }}</span>
                </div>
                <div class="report-card-phone">报告预留联系电话：{{ item.lxdh }}</div>
              </div>
            </div>

            <button
              v-if="reportRecords.length"
              type="button"
              class="track-more"
              @click="clearReportRecords"
            >清空查询记录</button>
          </div>
        </div>
      </div>
    </div>

    <!-- 报告查询行为验证码弹窗 -->
    <div v-if="reportCaptchaVisible" class="detail-mask" @click.self="closeReportCaptcha">
      <div class="detail-dialog report-captcha-dialog">
        <div class="detail-title">安全校验</div>
        <div id="report-captcha-box" class="report-captcha-host"></div>
      </div>
    </div>

    <!-- 咨询详情弹窗 -->
    <div v-if="detailVisible" class="detail-mask" @click.self="closeDetail">
      <div class="detail-dialog">
        <div class="detail-head">
          <span class="detail-title">{{ detail.title }}</span>
          <span class="track-status" :class="detail.status">{{ statusText(detail.status) }}</span>
        </div>
        <div class="detail-meta">
          <span>咨询类型：{{ detail.consultTypeName || '未分类' }}</span>
          <span>提交时间：{{ formatTime(detail.crTime) }}</span>
        </div>
        <div class="detail-content">{{ detail.content }}</div>

        <div class="detail-section-title">处理记录</div>
        <div v-if="!detail.replies || !detail.replies.length" class="detail-empty">暂无处理记录</div>
        <div class="reply-list">
          <div
            v-for="reply in (detail.replies || [])"
            :key="reply.id"
            class="reply-item"
            :class="{ user: reply.isUser === 1 }"
          >
            <div class="reply-head">
              <span class="reply-name">{{ reply.replierName || (reply.isUser === 1 ? '我' : '客服') }}</span>
              <span class="reply-time">{{ formatTime(reply.crTime) }}</span>
            </div>
            <div class="reply-content">{{ reply.content }}</div>
          </div>
        </div>

        <div v-if="detail.status !== 'closed'" class="detail-reply-form">
          <textarea v-model.trim="replyContent" class="form-textarea" placeholder="补充说明或继续提问..." rows="3" maxlength="300"></textarea>
          <div class="detail-reply-actions">
            <button type="button" class="reply-btn close-btn" :disabled="detailLoading" @click="closeConsult">关闭咨询</button>
            <button type="button" class="reply-btn submit-btn" :disabled="detailLoading || !replyContent" @click="submitReply">
              {{ detailLoading ? '提交中...' : '提交追问' }}
            </button>
          </div>
        </div>

        <div class="detail-close" @click="closeDetail">关闭</div>
      </div>
    </div>
  </div>
</template>

<script>
import { consultApi, reportApi } from '@/api'

const STATUS_MAP = {
  pending: '待受理',
  processing: '处理中',
  replied: '已回复',
  closed: '已关闭'
}

const STATUS_FILTERS = [
  { value: 'all', label: '全部' },
  { value: 'pending', label: '待受理' },
  { value: 'processing', label: '处理中' },
  { value: 'replied', label: '已回复' },
  { value: 'closed', label: '已关闭' }
]

const CAPTCHA_SDK_JS = 'https://cdn.jsdelivr.net/npm/captcha-web-sdk@1.0.11/dist/tac/js/tac.min.js'
const CAPTCHA_SDK_CSS = 'https://cdn.jsdelivr.net/npm/captcha-web-sdk@1.0.11/dist/tac/css/tac.min.css'
const REPORT_CAPTCHA_HOST_ID = 'report-captcha-box'

let captchaSdkPromise = null

function loadCaptchaStyle() {
  if (document.querySelector(`link[data-captcha-sdk="${CAPTCHA_SDK_CSS}"]`)) {
    return
  }
  const link = document.createElement('link')
  link.rel = 'stylesheet'
  link.href = CAPTCHA_SDK_CSS
  link.dataset.captchaSdk = CAPTCHA_SDK_CSS
  document.head.appendChild(link)
}

function loadCaptchaScript() {
  if (window.TAC) {
    return Promise.resolve(window.TAC)
  }
  if (!captchaSdkPromise) {
    captchaSdkPromise = new Promise((resolve, reject) => {
      const script = document.createElement('script')
      script.src = CAPTCHA_SDK_JS
      script.async = true
      script.onload = () => {
        if (window.TAC) {
          resolve(window.TAC)
          return
        }
        reject(new Error('验证码 SDK 未正确加载'))
      }
      script.onerror = () => reject(new Error('验证码 SDK 加载失败'))
      document.body.appendChild(script)
    })
  }
  return captchaSdkPromise
}

function extractCaptchaToken(response) {
  const payload = response && response.data !== undefined ? response.data : response
  if (!payload) return ''
  return payload.captchaToken || (payload.data && payload.data.captchaToken) || ''
}

export default {
  name: 'Contact',
  data() {
    return {
      contactInfo: {
        address: '贵州省遵义市播州区芶江镇贵州苟江经济开发区苟江标准厂房E栋',
        phone: '0851-23212555',
        email: 'service@zysjkxjc.com',
        workingHours: '周一至周五 9:00-18:00'
      },
      consultTab: 'submit',
      consultTypes: [],
      form: {
        consultTypeId: null,
        title: '',
        content: '',
        contactName: '',
        contactPhone: ''
      },
      submitting: false,
      // 跟踪
      trackPhone: '',
      trackStatus: 'all',
      trackSearched: false,
      trackList: [],
      trackPage: 1,
      trackPageSize: 10,
      trackTotal: 0,
      trackLoading: false,
      statusFilters: STATUS_FILTERS,
      // 详情
      detailVisible: false,
      detail: {},
      detailLoading: false,
      replyContent: '',
      // 报告查询（检品编号+委托单位+报告预留联系电话，三项一致方可查询）
      reportForm: {
        jybh: '',
        wtdw: '',
        lxdh: ''
      },
      reportQuerying: false,
      reportCaptchaLoading: false,
      reportCaptchaVisible: false,
      reportTacInstance: null,
      reportResult: '',
      // 我的报告（本机浏览器缓存的查询记录）
      reportRecords: []
    }
  },
  computed: {
    selectedTypeContact() {
      if (!this.form.consultTypeId) return ''
      const item = this.consultTypes.find(t => t.id === this.form.consultTypeId)
      return item ? (item.contactNo || '') : ''
    },
    trackHasMore() {
      return this.trackPage * this.trackPageSize < this.trackTotal
    },
    reportQueryText() {
      if (this.reportQuerying) return '查询中...'
      if (this.reportCaptchaLoading) return '加载验证码...'
      return '查询报告'
    }
  },
  mounted() {
    this.loadTypes()
    this.loadReportRecords()
  },
  beforeDestroy() {
    this.destroyReportCaptcha()
  },
  methods: {
    switchTab(tab) {
      this.consultTab = tab
      if (tab === 'mine') {
        this.loadReportRecords()
      }
    },
    async loadTypes() {
      try {
        const res = await consultApi.getTypes()
        this.consultTypes = (res && res.data) || []
      } catch (e) {
        // 静默
      }
    },
    validateForm() {
      const f = this.form
      if (!f.consultTypeId) return '请选择咨询类型'
      if (!f.title) return '请输入咨询标题'
      if (!f.content) return '请输入咨询内容'
      if (!f.contactName) return '请输入联系人姓名'
      if (!f.contactPhone) return '请输入联系电话'
      if (!/^1\d{10}$/.test(f.contactPhone)) return '请输入正确的11位手机号'
      return ''
    },
    async submitConsult() {
      const msg = this.validateForm()
      if (msg) {
        alert(msg)
        return
      }
      this.submitting = true
      try {
        await consultApi.submit({ ...this.form })
        alert('咨询提交成功，我们会尽快与您联系')
        this.form.title = ''
        this.form.content = ''
        // 保留联系人与类型，方便继续查询
        this.trackPhone = this.form.contactPhone
        this.switchTab('track')
        this.searchTrack()
      } catch (e) {
        alert((e && e.response && e.response.data && e.response.data.message) || '提交失败，请稍后重试')
      } finally {
        this.submitting = false
      }
    },
    // 跟踪查询
    async searchTrack() {
      if (!this.trackPhone) {
        alert('请输入手机号')
        return
      }
      if (!/^1\d{10}$/.test(this.trackPhone)) {
        alert('请输入正确的11位手机号')
        return
      }
      this.trackPage = 1
      this.trackSearched = true
      await this.fetchTrackList()
    },
    changeStatus(val) {
      this.trackStatus = val
      this.trackPage = 1
      this.fetchTrackList()
    },
    async fetchTrackList() {
      this.trackLoading = true
      try {
        const res = await consultApi.page({
          contactPhone: this.trackPhone,
          status: this.trackStatus,
          page: this.trackPage,
          pageSize: this.trackPageSize
        })
        const list = (res && res.data) || []
        this.trackList = this.trackPage === 1 ? list : this.trackList.concat(list)
        this.trackTotal = (res && res.total) || list.length
      } catch (e) {
        alert((e && e.response && e.response.data && e.response.data.message) || '查询失败')
        this.trackList = []
        this.trackTotal = 0
      } finally {
        this.trackLoading = false
      }
    },
    async loadMore() {
      this.trackPage += 1
      await this.fetchTrackList()
    },
    // 详情
    async openDetail(id) {
      this.detailVisible = true
      this.detail = {}
      this.replyContent = ''
      try {
        const res = await consultApi.getDetail(id, this.trackPhone)
        this.detail = (res && res.data) || {}
      } catch (e) {
        alert((e && e.response && e.response.data && e.response.data.message) || '加载失败')
      }
    },
    closeDetail() {
      this.detailVisible = false
      this.detail = {}
      this.replyContent = ''
    },
    async submitReply() {
      if (!this.replyContent) return
      this.detailLoading = true
      try {
        await consultApi.reply(this.detail.id, this.trackPhone, this.replyContent)
        this.replyContent = ''
        const res = await consultApi.getDetail(this.detail.id, this.trackPhone)
        this.detail = (res && res.data) || {}
      } catch (e) {
        alert((e && e.response && e.response.data && e.response.data.message) || '提交失败')
      } finally {
        this.detailLoading = false
      }
    },
    async closeConsult() {
      if (!confirm('确定要关闭该咨询吗？')) return
      this.detailLoading = true
      try {
        await consultApi.close(this.detail.id, this.trackPhone)
        const res = await consultApi.getDetail(this.detail.id, this.trackPhone)
        this.detail = (res && res.data) || {}
        this.fetchTrackList()
      } catch (e) {
        alert((e && e.response && e.response.data && e.response.data.message) || '关闭失败')
      } finally {
        this.detailLoading = false
      }
    },
    statusText(val) {
      return STATUS_MAP[val] || val || ''
    },
    // 报告查询
    async queryReport() {
      if (this.reportQuerying || this.reportCaptchaLoading) return
      const msg = this.validateReportForm()
      if (msg) {
        alert(msg)
        return
      }
      this.reportResult = ''
      await this.openReportCaptcha()
    },
    validateReportForm() {
      const f = this.reportForm
      if (!f.jybh) return '请输入检品编号'
      if (!f.wtdw) return '请输入委托单位'
      if (!f.lxdh) return '请输入报告预留联系电话'
      return ''
    },
    async openReportCaptcha() {
      this.reportCaptchaLoading = true
      this.reportCaptchaVisible = true
      await this.$nextTick()
      this.resetReportCaptchaHost()
      this.destroyReportCaptcha()
      try {
        loadCaptchaStyle()
        const TAC = await loadCaptchaScript()
        const tac = new TAC(
          {
            bindEl: `#${REPORT_CAPTCHA_HOST_ID}`,
            requestCaptchaDataUrl: reportApi.captchaUrls().requestCaptchaDataUrl,
            validCaptchaUrl: reportApi.captchaUrls().validCaptchaUrl,
            validSuccess: async (response, captcha, tacInstance) => {
              const captchaToken = extractCaptchaToken(response)
              if (!captchaToken) {
                alert('验证码校验成功，但未获取到 captchaToken')
                tacInstance.reloadCaptcha()
                return
              }
              tacInstance.destroyWindow()
              this.reportCaptchaVisible = false
              await this.submitReportQuery(captchaToken)
            },
            validFail: (response, captcha, tacInstance) => {
              const payload = response && response.data !== undefined ? response.data : response
              const msg = (payload && (payload.message || payload.msg)) || '验证码校验失败，请重试'
              alert(msg)
              tacInstance.reloadCaptcha()
            },
            btnCloseFun: (event, tacInstance) => {
              tacInstance.destroyWindow()
              this.reportCaptchaVisible = false
            },
            i18n: {
              tips_error: '验证码校验失败，请重新尝试',
              tips_network_error: '验证码网络异常，请稍后再试'
            }
          },
          {
            logoUrl: null
          }
        )
        this.reportTacInstance = tac
        tac.init()
      } catch (error) {
        this.reportCaptchaVisible = false
        alert((error && error.message) || '验证码加载失败')
      } finally {
        this.reportCaptchaLoading = false
      }
    },
    async submitReportQuery(captchaToken) {
      this.reportQuerying = true
      try {
        const res = await reportApi.queryReport({
          jybh: this.reportForm.jybh,
          wtdw: this.reportForm.wtdw,
          lxdh: this.reportForm.lxdh,
          captchaToken
        })
        const reportId = String((res && res.data !== undefined ? res.data : res) || '')
        this.reportResult = reportId
        if (!reportId) {
          alert('查询成功，但未获取到报告编号，请联系客服确认')
          return
        }
        // 缓存查询条件与报告编号到本机浏览器
        this.reportRecords = reportApi.saveRecord({
          jybh: this.reportForm.jybh,
          wtdw: this.reportForm.wtdw,
          lxdh: this.reportForm.lxdh,
          reportId: reportId,
          crTime: new Date().toISOString()
        })
      } catch (e) {
        alert((e && e.response && e.response.data && e.response.data.message) || '查询失败，请核对检品编号、委托单位与联系电话')
        this.reportResult = ''
      } finally {
        this.reportQuerying = false
      }
    },
    resetReportCaptchaHost() {
      const host = document.getElementById(REPORT_CAPTCHA_HOST_ID)
      if (host) host.innerHTML = ''
    },
    destroyReportCaptcha() {
      if (this.reportTacInstance && typeof this.reportTacInstance.destroyWindow === 'function') {
        this.reportTacInstance.destroyWindow()
      }
      this.reportTacInstance = null
    },
    closeReportCaptcha() {
      this.reportCaptchaVisible = false
      this.destroyReportCaptcha()
      this.resetReportCaptchaHost()
    },
    goMyReports() {
      this.switchTab('mine')
    },
    // 我的报告（本机缓存）
    loadReportRecords() {
      this.reportRecords = reportApi.getRecords()
    },
    clearReportRecords() {
      if (!confirm('确定清空当前浏览器的报告查询记录吗？')) return
      reportApi.clearRecords()
      this.loadReportRecords()
    },
    previewReport(reportId) {
      const url = reportApi.buildReportPreviewUrl(reportId)
      if (url) window.open(url, '_blank')
    },
    downloadReport(reportId) {
      const url = reportApi.buildReportPreviewUrl(reportId)
      if (!url) return
      const link = document.createElement('a')
      link.href = url
      link.target = '_blank'
      link.rel = 'noopener'
      link.download = `检测报告-${reportId}.pdf`
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    formatTime(val) {
      if (!val) return ''
      return String(val).replace('T', ' ').slice(0, 16)
    }
  }
}
</script>

<style scoped>
.contact {
  padding: 0;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 20px;
}

.contact__title {
  text-align: center;
  font-size: 36px;
  font-weight: 600;
  margin-bottom: 40px;
  color: #333;
}

.contact__content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 40px;
}

/* 联系方式样式 */
.contact__info {
  background-color: #f9f9f9;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.contact__info-title {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 20px;
  color: #333;
}

.contact__info-list {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.contact__info-item {
  display: flex;
  align-items: flex-start;
  gap: 15px;
}

.contact__info-icon {
  color: #007bff;
  margin-top: 2px;
  flex-shrink: 0;
}

.contact__info-text h3 {
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 5px;
  color: #555;
}

.contact__info-text p {
  font-size: 14px;
  color: #666;
  margin: 0;
  line-height: 1.5;
}

/* 咨询面板 */
.consult-panel {
  background-color: #ffffff;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.consult-tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 4px 8px;
  margin-bottom: 24px;
  border-bottom: 1px solid #eee;
}

.consult-tab {
  padding: 10px 20px;
  border: none;
  background: transparent;
  font-size: 15px;
  font-weight: 600;
  color: #888;
  cursor: pointer;
  border-bottom: 2px solid transparent;
  transition: all 0.3s;
}

.consult-tab.active {
  color: #007bff;
  border-bottom-color: #007bff;
}

.consult-form {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.form-label {
  font-size: 14px;
  font-weight: 500;
  color: #555;
}

.required {
  color: #ef4444;
  margin-left: 2px;
}

.form-control,
.form-textarea {
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  transition: border-color 0.3s;
  font-family: inherit;
  background: #fff;
}

.form-control:focus,
.form-textarea:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.1);
}

.form-textarea {
  resize: vertical;
  min-height: 100px;
}

select.form-control {
  appearance: auto;
  cursor: pointer;
}

.form-submit {
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 12px 20px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.3s;
  margin-top: 6px;
}

.form-submit:hover {
  background-color: #0069d9;
}

.form-submit:disabled {
  background-color: #6c757d;
  cursor: not-allowed;
}

.type-contact-tip {
  font-size: 13px;
  color: #28a745;
  background: rgba(40, 167, 69, 0.08);
  padding: 8px 12px;
  border-radius: 4px;
}

/* 我的咨询 */
.consult-track {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.track-search {
  display: flex;
  gap: 10px;
}

.track-search .form-control {
  flex: 1;
}

.track-search-btn {
  padding: 0 20px;
  border: none;
  border-radius: 4px;
  background-color: #007bff;
  color: #fff;
  font-size: 14px;
  cursor: pointer;
}

.track-search-btn:disabled {
  background-color: #6c757d;
  cursor: not-allowed;
}

.track-status-bar {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.status-chip {
  padding: 6px 14px;
  border: 1px solid #ddd;
  border-radius: 999px;
  background: #fff;
  color: #666;
  font-size: 13px;
  cursor: pointer;
}

.status-chip.active {
  background: #007bff;
  border-color: #007bff;
  color: #fff;
}

.track-state {
  text-align: center;
  color: #999;
  padding: 30px 0;
  font-size: 14px;
}

.track-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.track-card {
  padding: 16px;
  border: 1px solid #eee;
  border-radius: 8px;
  cursor: pointer;
  transition: box-shadow 0.3s;
}

.track-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.track-card-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  margin-bottom: 8px;
}

.track-title {
  font-size: 15px;
  font-weight: 600;
  color: #333;
}

.track-status {
  font-size: 12px;
  padding: 2px 10px;
  border-radius: 999px;
  white-space: nowrap;
  font-weight: 600;
}

.track-status.pending {
  background: #e8eefc;
  color: #4080e9;
}

.track-status.processing {
  background: #fff4e6;
  color: #f59e0b;
}

.track-status.replied {
  background: #e6f7ee;
  color: #22c55e;
}

.track-status.closed {
  background: #edf0f5;
  color: #7b879b;
}

.track-meta {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  color: #888;
  margin-bottom: 6px;
}

.track-content {
  font-size: 13px;
  color: #555;
  line-height: 1.6;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.track-more {
  align-self: center;
  padding: 8px 24px;
  border: 1px solid #ddd;
  border-radius: 999px;
  background: #fff;
  color: #666;
  font-size: 13px;
  cursor: pointer;
}

.track-more:disabled {
  color: #aaa;
  cursor: not-allowed;
}

/* 报告服务 */
.report-query,
.report-mine {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.report-security-tip {
  font-size: 13px;
  color: #8c95a8;
  line-height: 1.6;
}

.report-result {
  margin-top: 8px;
  padding: 18px;
  border: 1px solid #dcefe3;
  border-radius: 8px;
  background: #f4fbf6;
}

.report-result-head {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
}

.report-result-title {
  font-size: 16px;
  font-weight: 700;
  color: #22c55e;
}

.report-result-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 6px 18px;
  font-size: 13px;
  color: #555;
  margin-bottom: 14px;
}

.report-result-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
}

.report-action-btn {
  padding: 8px 18px;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
}

.report-action-btn.preview {
  background: #007bff;
  color: #fff;
}

.report-action-btn.preview:hover {
  background-color: #0069d9;
}

.report-action-btn.download {
  background: #22c55e;
  color: #fff;
}

.report-action-btn.download:hover {
  background-color: #16a34a;
}

.report-mine-tip {
  font-size: 13px;
  color: #8c95a8;
  line-height: 1.6;
}

.report-card-actions {
  display: flex;
  gap: 12px;
  align-items: center;
}

.report-card-link {
  border: none;
  background: transparent;
  padding: 0;
  font-size: 13px;
  color: #007bff;
  text-decoration: none;
  white-space: nowrap;
  cursor: pointer;
}

.report-card-link:hover {
  text-decoration: underline;
}

.report-card-phone {
  font-size: 12px;
  color: #888;
}

.report-captcha-host {
  min-height: 40px;
  width: 100%;
  overflow: auto;
  display: flex;
  justify-content: center;
}

@media (max-width: 768px) {
  .consult-tab {
    padding: 10px 12px;
    font-size: 14px;
  }
}

/* 详情弹窗 */
.detail-mask {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.detail-dialog {
  width: min(100%, 560px);
  max-height: 85vh;
  overflow-y: auto;
  background: #fff;
  border-radius: 12px;
  padding: 28px 24px;
}

.detail-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
}

.detail-title {
  font-size: 18px;
  font-weight: 700;
  color: #222;
}

.detail-meta {
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: 12px;
  color: #888;
  margin-bottom: 14px;
}

.detail-content {
  padding: 14px;
  background: #f8f9fa;
  border-radius: 8px;
  font-size: 14px;
  color: #444;
  line-height: 1.7;
  margin-bottom: 20px;
}

.detail-section-title {
  font-size: 15px;
  font-weight: 600;
  color: #333;
  margin-bottom: 12px;
}

.detail-empty {
  text-align: center;
  color: #aaa;
  padding: 20px 0;
  font-size: 13px;
}

.reply-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 20px;
}

.reply-item {
  padding: 12px 14px;
  border-radius: 8px;
  background: #f8f9fa;
}

.reply-item.user {
  background: #eef5ff;
}

.reply-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 6px;
}

.reply-name {
  font-size: 13px;
  font-weight: 600;
  color: #333;
}

.reply-time {
  font-size: 12px;
  color: #999;
}

.reply-content {
  font-size: 14px;
  color: #444;
  line-height: 1.6;
}

.detail-reply-form {
  border-top: 1px solid #eee;
  padding-top: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.detail-reply-actions {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
}

.reply-btn {
  padding: 8px 18px;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
}

.reply-btn.close-btn {
  background: #f1f3f5;
  color: #666;
}

.reply-btn.submit-btn {
  background: #007bff;
  color: #fff;
}

.reply-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.detail-close {
  text-align: center;
  margin-top: 16px;
  font-size: 14px;
  color: #999;
  cursor: pointer;
}

/* 响应式布局 */
@media (max-width: 768px) {
  .contact__content {
    grid-template-columns: 1fr;
    gap: 30px;
  }

  .contact__title {
    font-size: 24px;
    margin-bottom: 30px;
  }

  .contact__info,
  .consult-panel {
    padding: 20px;
  }

  .contact__info-title,
  .consult-tabs {
    font-size: 18px;
  }
}

@media (max-width: 480px) {
  .contact {
    padding: 20px 0;
  }

  .contact__title {
    font-size: 20px;
    margin-bottom: 20px;
  }

  .contact__info,
  .consult-panel {
    padding: 15px;
  }

  .contact__info-item {
    gap: 10px;
  }

  .form-control,
  .form-textarea {
    padding: 10px;
  }

  .form-submit {
    padding: 10px 16px;
  }
}
</style>
